import api from '@/api'

export default {
  namespaced: true,
  state: {
    products: [],
    waitlistInfo: {},
    isLoading: false,
    productsStatuses: {},
    waitListStatusInShops: {}
  },
  getters: {
    waitlistQuantity ({ waitlistInfo }) {
      if (!waitlistInfo) return null

      return waitlistInfo.goods_all ? waitlistInfo.goods_all : null
    },
    productsIdsInWaitlist ({ waitlistInfo }) {
      if (!waitlistInfo) return []

      return waitlistInfo.products_ids ? waitlistInfo.products_ids : []
    },
    productsForRender ({ products }, { productsIdsInWaitlist }) {
      if (!products) return []

      return products.filter(x => productsIdsInWaitlist.includes(x.id))
    }
  },
  mutations: {
    SET_WAITLIST_INFO (state, info) {
      state.products = [...state.products, ...info.products]
      state.waitlistInfo = info
    },
    SET_SHORT_WAITLIST_INFO (state, info) {
      state.waitlistInfo = { ...state.waitlistInfo, ...info }
    },
    SET_IS_LOADING (state, bool) {
      state.isLoading = bool
    },
    RESET_WAITLIST_INFO (state) {
      state.products = []
      state.waitlistInfo.offset = 0
    },
    SET_WAIT_LIST_STATUS_IN_SHOPS: (state, data) => {
      state.waitListStatusInShops[data.store_id] = data.is_in_wait_list
    },
    UPDATE_WAIT_LIST_STATUS_IN_SHOPS: (state, data) => {
      const clonedObj = { ...state.waitListStatusInShops }

      clonedObj[data.store_id] = !clonedObj[data.store_id]

      state.waitListStatusInShops = clonedObj
    }
  },
  actions: {
    GET_WAITLIST_INFO ({ commit, state }) {
      const params = {}

      if (state.waitlistInfo?.offset) params.offset = state.waitlistInfo.offset

      commit('SET_IS_LOADING', true)

      api.cabinet.getWaitlist(params)
        .then(res => {
          if (res.status === 'success') {
            commit('SET_WAITLIST_INFO', res)
          }
        })
        .finally(() => {
          commit('SET_IS_LOADING', false)
        })
    },
    CHANGE_WAIT_LIST_STATUS: ({ commit, state, rootGetters }, payload) => {
      return new Promise((resolve, reject) => {
        api.cabinet.changeWaitlistStatus(payload.postData)
          .then(response => {
            if (response.success === true) {
              if (!payload.postData.store_id) commit('SET_SHORT_WAITLIST_INFO', response.waitlist)
              else commit('UPDATE_WAIT_LIST_STATUS_IN_SHOPS', payload.postData)
              resolve(response)
            } else {
              reject(response.message)
            }
          })
          .catch(error => reject(error))
      })
    },
    SET_SHORT_WAITLIST_INFO_ACTION ({ commit }, info) {
      commit('SET_SHORT_WAITLIST_INFO', info)
    },
    RESET_WAITLIST_INFO_ACTION ({ commit }) {
      commit('RESET_WAITLIST_INFO')
    }
  }
}
